import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function getProcessAlarm(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}process/alarm/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getHardwareAlarm(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}hardware/alarm/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
